export const getNewsLabel = (dir, dirToLabelMap) => dirToLabelMap[parseInt(dir)];
